// extracted by mini-css-extract-plugin
module.exports = {"row":"FoodSidebarCheckoutButton_row__3Wp76","button":"FoodSidebarCheckoutButton_button__1U6-K","button-ltr":"FoodSidebarCheckoutButton_button-ltr__1Qrms"};